// dateTimeUtils.js

/**
 * Formata uma data ou string de data/hora para o formato HH:mm
 * @param {Date | string} datetime - O objeto Date ou string.
 * @returns {string} - A hora formatada como HH:mm.
 */
export const formatTime = (datetime) => {
    const date = new Date(datetime);
    const hours = String(date.getHours()).padStart(2, '0'); // Garante dois dígitos
    const minutes = String(date.getMinutes()).padStart(2, '0'); // Garante dois dígitos
    return `${hours}:${minutes}`;
};

/**
 * Formata uma data ou string de data/hora para o formato dd/mm/yyyy
 * @param {Date | string} datetime - O objeto Date ou string.
 * @returns {string} - A data formatada como dd/mm/yyyy.
 */
export const formatDate = (datetime) => {
    try
    {
        const date = new Date(datetime);
        const day = String(date.getDate()).padStart(2, '0'); // Garante dois dígitos
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Meses começam do zero
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }   
    catch (error)
    {
        return datetime;
    }    
};

export const formatDateInput = (datetime) => {
    try
    {
        const date = new Date(datetime);
        const day = String(date.getDate()).padStart(2, '0'); // Garante dois dígitos
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Meses começam do zero
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
    }   
    catch (error)
    {
        return datetime;
    }    
};


export const isValidDate = (dateString) => {
    const dateParts = dateString.split('-');
    if (dateParts.length !== 3) return false; // Verifica se tem 3 partes

    const year = parseInt(dateParts[0], 10);
    const month = parseInt(dateParts[1], 10); // Mês começa em 0
    const day = parseInt(dateParts[2], 10);

    // Cria um objeto Date com os valores
    const date = new Date(year, month, day);

    if (date.getFullYear() < 1920) return false; // Verifica se o ano é maior que 1900
    if (date.getFullYear() > 2050) return false; // Verifica se o ano é menor que 2050

    return true;
}

export function formatHora(dateTime) {
  if (!dateTime) return "";

  try {
    const data = new Date(dateTime);

    const horas = data.getHours().toString().padStart(2, "0");
    const minutos = data.getMinutes().toString().padStart(2, "0");

    return `${horas}:${minutos}`;
  } catch (e) {
    return "";
  }
}